// ─── Category config ──────────────────────────────────────────────────────────
export const CAT_CONFIG = {
  sport:         { label: 'Sport',      color: '#FF6B6B', bg: '#FFF0F0', emoji: '⚽' },
  creative:      { label: 'Kreatywne',  color: '#9575CD', bg: '#F3F0FF', emoji: '🎨' },
  nature:        { label: 'Przyroda',   color: '#66BB6A', bg: '#F0FFF1', emoji: '🌿' },
  educational:   { label: 'Edukacja',   color: '#FFB300', bg: '#FFFBE0', emoji: '🔬' },
  entertainment: { label: 'Rozrywka',   color: '#4FC3F7', bg: '#F0FAFF', emoji: '🎭' },
};

// ─── Filter definitions ───────────────────────────────────────────────────────
export const AGE_RANGES = [
  { id: '0-2',   label: '0–2 lat',   range: [0,  2]  },
  { id: '3-5',   label: '3–5 lat',   range: [3,  5]  },
  { id: '6-9',   label: '6–9 lat',   range: [6,  9]  },
  { id: '10-12', label: '10–12 lat', range: [10, 12] },
  { id: '13+',   label: '13+ lat',   range: [13, 99] },
];

export const CAT_FILTERS = Object.entries(CAT_CONFIG).map(([id, c]) => ({
  id,
  label: `${c.emoji} ${c.label}`,
  color: c.color,
}));

export const SETTING_FILTERS = [
  { id: 'indoor',  label: '🏠 Wnętrze' },
  { id: 'outdoor', label: '🌳 Plener'  },
];

export const PRICE_FILTERS = [
  { id: 'free',   label: '💚 Bezpłatne' },
  { id: 'budget', label: '💛 Do 50 zł'  },
  { id: 'paid',   label: '💳 Powyżej'   },
];

export const SETTING_LABEL = { indoor: 'W środku', outdoor: 'Na dworze', both: 'Oba' };
export const SETTING_ICON  = { indoor: '🏠', outdoor: '🌳', both: '🌤️' };
export const AMBER = '#F59E0B';

// ─── Seed data (replaced by Supabase in Screen 4) ────────────────────────────
export const SEED_ACTIVITIES = [
  {
    id: 1,
    name: 'Malarnia Wyobraźni',
    description: 'Warsztaty plastyczne dla dzieci rozwijające wyobraźnię i kreatywność. Malowanie, kolaże, rzeźba z gliny pod okiem animatorów.',
    category: 'creative',
    ageMin: 3,
    ageMax: 7,
    setting: 'indoor',
    priceType: 'budget',
    priceAmount: 35,
    address: 'ul. Marszałkowska 12',
    city: 'Warszawa',
    lat: 52.2297,
    lng: 21.0122,
    openingHours: 'Wt–Nd 10:00–18:00',
    phone: '+48 22 123 45 67',
    website: 'https://example.com',
    tags: ['malarstwo', 'warsztaty', 'kreatywność', 'glina'],
  },
  {
    id: 2,
    name: 'Centrum Nauki Kopernik',
    description: 'Interaktywne centrum z 450+ eksponatami. Eksperymenty, pokazy naukowe, fizyka i chemia dla ciekawskich umysłów.',
    category: 'educational',
    ageMin: 4,
    ageMax: 12,
    setting: 'indoor',
    priceType: 'budget',
    priceAmount: 28,
    address: 'Wybrzeże Kościuszkowskie 20',
    city: 'Warszawa',
    lat: 52.2415,
    lng: 21.0296,
    openingHours: 'Wt–Pt 9:00–18:00, Sb–Nd 10:00–19:00',
    phone: '+48 22 596 41 00',
    website: 'https://example.com',
    tags: ['nauka', 'eksperymenty', 'technika', 'fizyka'],
  },
  {
    id: 3,
    name: 'Ogród Botaniczny',
    description: '5000+ gatunków roślin z całego świata. Rodzinne spacery, obserwacja przyrody, fontanny i plac zabaw latem.',
    category: 'nature',
    ageMin: 3,
    ageMax: 10,
    setting: 'outdoor',
    priceType: 'free',
    priceAmount: 0,
    address: 'Al. Ujazdowskie 4',
    city: 'Warszawa',
    lat: 52.2152,
    lng: 21.0245,
    openingHours: 'Codziennie 10:00–20:00',
    phone: '+48 22 553 05 11',
    website: 'https://example.com',
    tags: ['natura', 'rośliny', 'spacer', 'fontanny'],
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
export function togArr(arr, v) {
  return arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v];
}

export function priceLabel(activity) {
  return activity.priceType === 'free' ? 'Bezpłatne' : `${activity.priceAmount} zł`;
}

export function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(a));
}

export function distLabel(activity, userLat, userLng) {
  if (userLat === null) return '— km';
  const d = haversine(userLat, userLng, activity.lat, activity.lng);
  return d < 1 ? `${(d * 1000).toFixed(0)} m` : `${d.toFixed(1)} km`;
}

export function applyFilters(activities, { ages, cats, settings, prices, radius, userLat, userLng }) {
  return activities.filter(a => {
    if (ages.length > 0) {
      const ok = ages.every(id => {
        const { range } = AGE_RANGES.find(r => r.id === id);
        return a.ageMax >= range[0] && a.ageMin <= range[1];
      });
      if (!ok) return false;
    }
    if (cats.length     > 0 && !cats.includes(a.category))    return false;
    if (settings.length > 0 && !settings.includes(a.setting)) return false;
    if (prices.length   > 0 && !prices.includes(a.priceType)) return false;
    if (radius && userLat !== null) {
      const d = haversine(userLat, userLng, a.lat, a.lng);
      if (d > radius) return false;
    }
    return true;
  });
}

export function sortByDistance(activities, userLat, userLng) {
  if (userLat === null) return activities;
  return [...activities].sort((a, b) =>
    haversine(userLat, userLng, a.lat, a.lng) -
    haversine(userLat, userLng, b.lat, b.lng)
  );
}
export const RADIUS_OPTIONS = [
  { id: '1',  label: '1 km',  km: 1  },
  { id: '5',  label: '5 km',  km: 5  },
  { id: '15', label: '15 km', km: 15 },
  { id: '30', label: '30 km', km: 30 },
];
